import React from "react";
import TwitterIcon from "@material-ui/icons/Twitter";
import GitHubIcon from "@material-ui/icons/GitHub";
import InstagramIcon from "@material-ui/icons/Instagram";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import MailIcon from "@material-ui/icons/Mail";

import ReactLogo from "../assets/images/logo-white.svg";
const Footer = () => {
  return (
    <footer className="footer">
      <a href="/" className="footer__logo">
        <img src={ReactLogo} alt="logo" className="footer__logo-img rotate-center" />
        <span>Amit Singh</span>
      </a>
      <p className="footer__heading">Let's get Social !</p>
      <nav className="footer__list-container">
        <ul className="footer__list">
          <li>
            <a href="https://twitter.com/AmitSin06326070" target="blank">
              <TwitterIcon fontSize="large" />
            </a>
          </li>
          <li>
            <a href="https://github.com/amitsingh777" target="blank">
              <GitHubIcon fontSize="large" />
            </a>
          </li>
          <li>
            <a
              href="https://www.instagram.com/a_myth_singh910/"
              target="blank"
            >
              <InstagramIcon fontSize="large" />
            </a>
          </li>
          <li>
            <a
              href="https://www.linkedin.com/in/amit-singh-a97544154/"
              target="blank"
            >
              <LinkedInIcon fontSize="large" />
            </a>
          </li>
          <li>
            <a href="mailto:amitbrajeshsingh@gmail.com" target="blank">
              <MailIcon fontSize="large" />
            </a>
          </li>
        </ul>
      </nav>
      <p className="footer__copyright">
        Copyrights @ 2020 Amit Singh.
        <br />
        All rights reserved.
      </p>
      
    </footer>
  );
};

export default Footer;
